import { ManualEstimateReviewStage } from "@rebuild/shared";

const ESTIMATE_APP_BASE_URL = import.meta.env.DEV ? "https://staging.rebuild.work" : "https://app.rebuild.work";

export const estimateUrl = (estimateId: string): string => `${ESTIMATE_APP_BASE_URL}/estimate/${estimateId}`;

/** Background/text classes for each stage badge, ordered light → advanced so stages are visually distinct. */
export const STAGE_BADGE_CLASSES: Record<ManualEstimateReviewStage, string> = {
  [ManualEstimateReviewStage.NotStarted]: "bg-gray-100 text-gray-700",
  [ManualEstimateReviewStage.InProgress]: "bg-blue-100 text-blue-700",
  [ManualEstimateReviewStage.InReview]: "bg-amber-100 text-amber-800",
  [ManualEstimateReviewStage.Approved]: "bg-purple-100 text-purple-700",
  [ManualEstimateReviewStage.Active]: "bg-green-100 text-green-700",
  [ManualEstimateReviewStage.Archived]: "bg-stone-200 text-stone-600",
};
